import { z } from "zod";

// Reject `javascript:`, `data:`, `vbscript:`, etc. — bookingUrl flows into an
// <a href> and facilityImage flows into a CSS url(...). Both XSS surfaces.
const httpUrl = z.string().regex(/^https?:\/\//i);

export const BookingCardSchema = z.object({
  facilityName: z.string().min(1),
  facilityImage: httpUrl,
  sport: z.string().min(1),
  surface: z.string().optional(),
  date: z.string().min(1),                 // YYYY-MM-DD
  time: z.string().min(1),                 // HH:MM (24h)
  duration: z.string().min(1),             // e.g. "1 hour"
  bookingUrl: httpUrl,
  address: z.string().optional(),
  subtotalCents: z.number(),
  taxCents: z.number().optional(),
  totalCents: z.number().optional(),
});

export type BookingCardData = z.infer<typeof BookingCardSchema>;

export function validateBookingCard(value: unknown): BookingCardData | null {
  const parsed = BookingCardSchema.safeParse(value);
  return parsed.success ? parsed.data : null;
}
